/**
 * Get the locale that is a case insensitive match in the available locales
 * @param languageCode the language code for the locale to look-up
 * @param countryCode the country code for the locale to look-up
 * @param availableLocales an object where the keys are locale codes and the values are locales
 * @returns {*}
 */
function getAvailableLocale(languageCode, countryCode, availableLocales) {
  const targetLocaleHyphen = `${languageCode}-${countryCode}`.toLowerCase();
  const targetLocaleUnderscore = `${languageCode}_${countryCode}`.toLowerCase();
  const localeCode = Object.keys(availableLocales).find(locale => {
    const lowerCaseLocale = locale.toLowerCase();
    return (
      lowerCaseLocale === targetLocaleHyphen ||
      lowerCaseLocale === targetLocaleUnderscore
    );
  });
  return availableLocales[localeCode];
}

/**
 * Get the locale that is the closest match to the one provided. Will first check for an exact match, then fall-back to
 * default locale for that language.
 * @param localeCode the code for the locale to look-up
 * @param availableLocales an object where the keys are locale codes and the values are locales
 * @param defaultLocales override for the default locale codes for languages
 * @returns {*}
 */
export default function getMatchingLocale(
  localeCode,
  availableLocales,
  defaultLocales = {
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    nl: 'nl-NL',
    pt: 'pt-PT',
    ru: 'ru-RU',
    zh: 'zh-CN'
  }
) {
  const [languageCode, countryCode] = localeCode.replace('_', '-').split('-');
  let availableLocale;
  if (countryCode) {
    availableLocale = getAvailableLocale(
      languageCode,
      countryCode,
      availableLocales
    );
    if (availableLocale) {
      return availableLocale;
    }
  }
  const defaultLocale = defaultLocales[languageCode];
  if (defaultLocale) {
    const [defaultLanguageCode, defaultCountryCode] = defaultLocale.split('-');
    availableLocale = getAvailableLocale(
      defaultLanguageCode,
      defaultCountryCode,
      availableLocales
    );
    if (availableLocale) {
      return availableLocale;
    }
  }
  throw new Error(`no available locale matching ${localeCode}`);
}
